import mediaController from "@helper/mediaController";
import { BeyondWordsPlayerInstance } from "@typings/BeyondWords";

export const registerMediaControllerEvents = (
  player: BeyondWordsPlayerInstance,
  articleId = "0",
  playerId?: string,
) => {
  const resolvedId = playerId || `beyondwords-${articleId}`;

  const controller = mediaController.register({
    type: "beyondwords",
    id: resolvedId,
    pause: () => {
      if (typeof player.stop === "function") {
        player.stop();
      } else {
        player.playbackState = "paused";
      }
    },
  });

  player.addEventListener("PressedPlay", () => {
    controller.onPlay();
  });

  player.addEventListener("PressedPause", () => {
    controller.onPause();
  });

  return controller;
};
